import type { FaireProductEntity } from "../../entity_types/product";

export const p_65t5hnjzur: FaireProductEntity = {
  token: "p_65t5hnjzur",
  type: "product",
  name: "Natural Garter Stitch Beanie Baby & Kids",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/9ceca469bb27862b2a7220a35c7e1d473070c2643e990a1ff9693da51a75f27a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21abf0b0ecbed7c6c510ffc48be7db7bbbe811087c79ae109bca2b3004678fe0.jpeg",
    "https://cdn.faire.com/fastly/0cb52b03a29da9848da119494e2fd082dda7df2a3eeaa8ce439ded4fbb4010d1.jpeg",
    "https://cdn.faire.com/fastly/7b07d4243807693ebc487170057b60bd07ac861997f6818dafb13c5832997404.jpeg",
    "https://cdn.faire.com/fastly/e1795352d64fda47a320c79f509d7a03894efdb6d1ead139e751afcb99b3af43.jpeg",
    "https://cdn.faire.com/fastly/8dafd78a676b04cb32ab81f8b3f1327f06aa3c7b5242c5cff9241e2b51beea6c.jpeg",
    "https://cdn.faire.com/fastly/7aea354c00f59d1ce0c761a77086704a99a16884d7faf7aac31e7e023e57943c.jpeg",
  ],
  priceDollars: 17,
  description:
    "Thick, soft beanie in is hand knit in garter stitch with a ribbed cuff and pom pom on tip. Hand-knit, in natural colored yarn, it is cozy and warm. The matching sweater you see here is available separately. Perfect for chilly weather and a great gift. 100% Acrylic. Cold handwash. Hand knit in China.",
  tags: [],
  msrpDollars: 34,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:14.227Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
